<template>
  <ion-page>
    <master-layout pageTitle="درخواست تامین کالا">

          <Loading :is="!orderLoaded" v-if="!orderLoaded"></Loading>
          <div v-if="orderLoaded">
            <div v-if="order">
              <h5 class="pr-1">
                شماره سفارش :
                {{order.order_number}}
              </h5>
              <h6 v-if="order.status === 21" class="text-danger">وضعیت : لغو شده</h6>
              <h6 v-else-if="order.status === 101" class="text-danger">وضعیت : درحال بررسی</h6>

              <div v-if="isConfirm" class="pr-1 text-danger">
                زمان باقی مانده برای ثبت سفارش :
                <timer :number="order.expire_time"></timer>
              </div>
              <ion-card v-if="existItems.length">
                <h4>کالاهای موجود در سفارش</h4>
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>اطلاعات</th>
                      <th>تعداد</th>
                      <th>مبلغ واحد</th>
                      <th>مبلغ کل</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in existItems" :key="index">
                      <td>{{item.title}}
                      <div>{{item.attr_string}}</div>
                      </td>
                      <td>
                        <money :number="item.quantity"></money></td>
                      <td>
                        <money :number="item.price"></money> تومان
                      </td>
                      <td>
                        <money :number="item.total"></money> تومان
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="text-danger pr-1">جمع کالاهای موجود :
                <money :number="existTotal"></money> تومان
                </div>
                <div class="text-danger pr-1">هزینه ارسال :
                  <money :number="order.shipping_cost"></money> تومان
                </div>
              </ion-card>
              <h4 v-if="isConfirm">کالاهای استعلام شده</h4>
              <ion-card v-if="!isConfirm">
                <h4 >کالاهایی که نیاز به استعلام دارن</h4>
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>اطلاعات</th>
                      <th>تعداد</th>
                      <th>مبلغ واحد</th>
                      <th>مبلغ کل</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in notExistItems" :key="index">
                      <td>{{item.title}}
                        <div>{{item.attr_string}}</div>
                      </td>
                      <td>
                        <money :number="item.quantity"></money></td>
                      <td>
                        0 تومان
                      </td>
                      <td>
                        0 تومان
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </ion-card>
              <div v-if="isConfirm">
              <ion-card  v-for="(item,index) in notExistItems" :key="index">
                <ion-card-content :class="(item.status === 'not_exist'?'not-exist-div':'')" >
                  <ion-grid>
                    <ion-row>
                      <ion-col size="5">
                        <img class="img" :src="item.thumbnail_url" :alt="item.title">
                        <div v-if="item.status === 'exist'">
                        <input @change="changeChecked(index)" autocomplete="off" type="checkbox" class="checkbox" :checked="item.checked"  hidden :id="'toggle_'+index" name="" value="">
                        <div class="toggle">
                          <label :for="'toggle_'+index"><i></i></label>
                        </div>
                        <button :disabled="wait_btn" @click="decrement(index)" class="input-number-decrement">–</button>
                        <input :disabled="wait_btn" @change="setQuantity($event,index)" class="input-number" type="tel" v-model="item.quantity" >
                        <button :disabled="wait_btn" @click="increment(index)" class="input-number-increment">+</button>
                        </div>
                      </ion-col>
                      <ion-col size="7">
                        <div class="p-info">
                          <div class="mb-1">
                            <i class="far fa-tag"></i>
                            {{item.title}}
                            <div>{{item.attr_string}}</div>
                          </div>
                          <div v-if="item.status === 'exist'">
                            <div class="justify-between mb-1">
                              <div>قیمت :</div>
                              <div>
                                <money :number="item.sell_price"></money>
                                تومان
                              </div>
                            </div>
                            <div class="justify-between mb-1">
                              <div>جمع :</div>
                              <div>
                                <money :number="item.total"></money>
                                تومان
                              </div>
                            </div>
                            <div class="min-max-amount text-danger">
                              <div>حداقل تعداد انتخاب :
                              {{item.min_amount}}
                              </div>
                              <div>حداکثر تعداد انتخاب :
                                {{item.max_amount}}
                              </div>
                            </div>
                          </div>
                          <div v-else-if="item.status === 'not_exist'" class="text-danger">
                            متأسفانه این کالا در حال حاضر موجود نمی باشد.
                          </div>
                          <div v-else-if="item.status === 'suggest'" class="text-danger">
                            متاسفانه این کالا در حال حاضر موجود نمی باشد.
                            در لیست زیر می توانید کالاهای مشابه را انتخاب کنید.
                            🔽
                          </div>
                        </div>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-card-content>
                <ion-card-content v-for="(i,index2) in item.items" :key="index2" class="suggest-item">
                  <ion-grid>
                    <ion-row>
                      <ion-col size="5">
                        <img class="img" :src="i.thumbnail_url" :alt="i.title">
                          <input @change="changeChecked(index,index2)"  :checked="i.checked" autocomplete="off" type="checkbox" class="checkbox"  hidden :id="'toggle_g'+index+'_'+index2" name="" value="">
                          <div class="toggle">
                            <label :for="'toggle_g'+index+'_'+index2"><i></i></label>
                          </div>
                          <button :disabled="wait_btn" @click="decrement(index,index2)" class="input-number-decrement">–</button>
                          <input :disabled="wait_btn" @change="setQuantity($event,index,index2)" class="input-number" type="tel" v-model="i.quantity" >
                          <button :disabled="wait_btn" @click="increment(index,index2)" class="input-number-increment">+</button>
                      </ion-col>
                      <ion-col size="7">
                        <div class="p-info">
                          <div class="mb-1">
                            <i class="far fa-tag"></i>
                            {{i.product_title}}
                            <div>{{i.attributes}}</div>
                          </div>
                            <div class="justify-between mb-1">
                              <div>قیمت :</div>
                              <div>
                                <money :number="i.sell_price"></money>
                                تومان
                              </div>
                            </div>
                            <div class="justify-between mb-1">
                              <div>جمع :</div>
                              <div>
                                <money :number="i.total"></money>
                                تومان
                              </div>
                            </div>
                        </div><div class="min-max-amount text-danger">
                        <div>حداقل تعداد انتخاب :
                          {{i.min_amount}}
                        </div>
                        <div>حداکثر تعداد انتخاب :
                          {{i.max_amount}}
                        </div>
                      </div>

                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-card-content>
              </ion-card>
              <ion-card>
               <ion-card-content>
                 <div>
                   جمع آیتم های انتخابی :
                   <money :number="selectedTotal"></money> تومان
                 </div>
                 <div>
                   جمع هزینه ارسال آیتم های انتخابی :
                   <money :number="selectedItemsSendCost"></money> تومان
                 </div>
               </ion-card-content>
              </ion-card>
              <ion-card>
                <ion-card-content>
                  <div>
                    جمع کل آیتم ها :
                    <money :number="total"></money> تومان
                  </div>
                  <div>
                    هزینه کلی ارسال :
                    <money :number="selectedItemsSendCost + order.shipping_cost"></money> تومان
                  </div>
                </ion-card-content>
              </ion-card>
              <ion-grid>
                <ion-row>
                  <ion-col size="6">
                    <ion-button @click="reRequestPreOrder" v-if="expired" color="secondary" expand="full">
                      درخواست مجدد
                      &nbsp;<i class="far fa-sync"></i>
                    </ion-button>
                    <ion-button @click="submitPreOrderFunc" v-else color="success" expand="full">
                      تایید وثبت سفارش
                      &nbsp;<i class="far fa-edit"></i>
                    </ion-button>
                  </ion-col>
                  <ion-col size="6">
                    <ion-button @click="cancelPreOrder" color="danger" expand="full">لغو کردن</ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
              </div>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>
          </div>

    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
import {IonPage, IonCard, IonCardContent, IonCardHeader, alertController} from '@ionic/vue';
import AjaxForm from "@/components/AjaxForm";
import Money from "@/components/Money";
import Timer from "@/components/Timer";
import {showSystemNoti} from "@/shared/helper";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    AjaxForm,Money,Timer,
    IonPage, IonCard, IonCardContent, IonCardHeader
  },
  data()
  {
    return {
      id: null,
      orderLoaded: false,
      order: null,
      error: null,
      existItems : [],
      notExistItems : [],
      wait_btn : false,
      existTotal : 0,
      total : 0,
      selectedTotal : 0,
      selectedItemsSendCost : 0,
      expired : false,
      isConfirm : false
    }
  },
  async created()
  {
    this.id = this.$route.params.id;
    await this.init();
  },
  methods: {
    ...mapActions("app", {
      getStates: 'getStates',
      apiGetCities: 'getCities',
    }),
    ...mapActions("shop", {
      getPreOrder: 'getPreOrder',
      reRequestPreOrderFunc : 'reRequestPreOrder',
      preOrderCancel : 'preOrderCancel',
      preOrderSubmit : 'preOrderSubmit',
    }),
    async init()
    {
      this.orderLoaded = false;
      this.order = null;
      this.expired = false;
      this.existItems = [];
      this.notExistItems = [];
      this.isConfirm = false;
      this.selectedItemsSendCost = 0;
      this.existTotal = 0;
      const result = await this.getPreOrder(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.orderLoaded = true;
          this.order = result.order;
          this.expired = result.expired;
          let sendCost = 0;
          if (!this.expired)
          {
            this.expireOrder(this.order.expire_time);
          }

          const notExistItems = result.not_exist_items;
          for (let i = 0; i < notExistItems.length; i++)
          {
            if (notExistItems[i].status === 'exist')
            {
              sendCost += notExistItems[i].send_cost
              notExistItems[i].quantity = notExistItems[i].min_amount;
              notExistItems[i].total = (notExistItems[i].sell_price * notExistItems[i].quantity)
              notExistItems[i].checked = true;
            }
            if (notExistItems[i].status === 'suggest')
            {
              const items = notExistItems[i].items;
              if (items)
              {
                for (let j = 0; j < items.length; j++)
                {
                  sendCost += items[j].send_cost
                  items[j].quantity = items[j].min_amount;
                  items[j].checked = true;
                  items[j].total = (items[j].sell_price * items[j].quantity);
                }
                notExistItems[i].items = items;
              }
            }
          }
          this.existItems = result.exist_items;
          this.notExistItems = notExistItems;
          this.isConfirm = result.is_confirm;
          this.selectedItemsSendCost = sendCost;
          
          let existTotal = 0;
          for (let i = 0; i < this.existItems.length; i++)
          {
            existTotal += this.existItems[i].total;
          }
          this.existTotal = existTotal;
          this.sumOrderItems();
        }
        else
        {
          this.orderLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.orderLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    expireOrder(time)
    {
      const self = this;
      const now = new Date().getTime();
      setTimeout(function() {
          self.expired = true;
      }, (time - now));
    },
    sumOrderItems()
    {
      const existTotal = this.existTotal;
      let total = 0;
      const nItems = this.notExistItems;
      let sendCost = 0;
      for (let i = 0; i < nItems.length; i++)
      {
        const item = nItems[i];
        if (item.checked && item.status === 'exist')
        {
          sendCost += item.send_cost;
          total += item.total;
        }
        else if (item.status === 'suggest')
        {
          if (item.items)
          {
            for (let j = 0; j < item.items.length; j++)
            {
              const s_item = item.items[j];
              if (s_item.checked)
              {
                sendCost += s_item.send_cost;
                total += s_item.total;
              }
            }
          }
        }
      }
      this.selectedItemsSendCost = sendCost;
      this.selectedTotal = total;
      total += existTotal;
      this.total = total;
    },
    changeChecked(index,index2 = null)
    {
      const item = this.notExistItems[index];
      if (item.status === 'suggest' && index2 !== null)
      {
        const item2 = item.items[index2];
        item2.checked = !item2.checked;
      }
      else if (item.status === 'exist')
      {
        item.checked = !item.checked;
      }
      this.sumOrderItems();
    },
    decrement(index,index2 = null)
    {
      const item = this.notExistItems[index];
      if (item.status === 'suggest' && index2 !== null)
      {
        const s_item = item.items[index2];
        const quantity = s_item.quantity;
        const min_quantity = s_item.min_amount;
        if ((quantity-1) >= min_quantity)
        {
          s_item.quantity = quantity -1;
          s_item.total = s_item.sell_price * s_item.quantity;
        }
      }
      else if (item.status === 'exist')
      {
        const item = this.notExistItems[index];
        const quantity = item.quantity;
        const min_quantity = item.min_amount;
        if ((quantity-1) >= min_quantity)
        {
          item.quantity = quantity -1;
          item.total = item.sell_price * item.quantity;
        }
      }
      this.sumOrderItems();
      //
    },
    increment(index,index2)
    {
      const item = this.notExistItems[index];
      if (item.status === 'suggest' && index2 !== null)
      {
        const s_item = item.items[index2];
        const quantity = s_item.quantity;
        const max_quantity = s_item.max_amount;
        if ((quantity+1) <= max_quantity)
        {
          s_item.quantity = quantity +1;
          s_item.total = s_item.sell_price * s_item.quantity;
        }
      }
      else if (item.status === 'exist')
      {
        const item = this.notExistItems[index];
        const quantity = item.quantity;
        const max_quantity = item.max_amount;
        if ((quantity+1) <= max_quantity)
        {
          item.quantity = quantity +1;
          item.total = item.sell_price * item.quantity;
        }
      }
      //
      this.sumOrderItems();
    },
    setQuantity(event,index,index2)
    {
      const val = parseInt(event.target.value);
      const item = this.notExistItems[index];
      if (isNaN(val))
      {
        if (item.status === 'exist')
        {
          event.target.value = item.quantity;
        }
        else
        {
          event.target.value = item.items[index2].quantity;
        }
          return;
      }
      if (item.status === 'suggest' && index2 !== null)
      {
        const s_item = item.items[index2];
        // const quantity = s_item.quantity;
        const min_quantity = s_item.min_amount;
        const max_quantity = s_item.max_amount;
        if (val >= min_quantity && val <= max_quantity)
        {
          s_item.quantity = val;
          s_item.total = s_item.sell_price * s_item.quantity;
        }
        else if (val < min_quantity)
        {
          s_item.quantity = min_quantity;
          s_item.total = s_item.sell_price * min_quantity;
        }
        else if (val > max_quantity)
        {
          s_item.quantity = max_quantity;
          s_item.total = s_item.sell_price * max_quantity;
        }
      }
      else if (item.status === 'exist')
      {
        const item = this.notExistItems[index];
        // const quantity = item.quantity;
        const max_quantity = item.max_amount;
        const min_quantity = item.min_amount;
        if (val <= max_quantity && val >= min_quantity)
        {
          item.quantity = val;
          item.total = item.sell_price * item.quantity;
        }
        else if (val < min_quantity)
        {
          item.quantity = min_quantity;
          item.total = item.sell_price * item.quantity;
        }
        else if (val > max_quantity)
        {
          item.quantity = max_quantity;
          item.total = item.sell_price * item.quantity;
        }
      }
      this.sumOrderItems();
    },
    async reRequestPreOrder()
    {
      const self = this;
      const check = await this.reRequestPreOrderFunc(this.order._id);
      if (check.ok)
      {
        showSystemNoti('success',check.message,function (){
          self.init();
        });
      }
      else
        return showSystemNoti('danger',check.error);
    },
    async cancelPreOrder ()
    {
      const self = this;
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'آیا اطمینان دارید!',
            message: 'سفارش لغو شود.',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  const check = await this.preOrderCancel(self.order._id);
                  if (check.ok)
                  {
                    return showSystemNoti('success',check.message,function (){
                      self.init();
                    });
                  }
                  else
                    return showSystemNoti('success',check.error);
                },
              },
            ],
          });
      return alert.present();
    },
    async submitPreOrderFunc()
    {
      const self = this;
      const out = [];
      const n_items = this.notExistItems;
      for (let i = 0; i < n_items.length; i++)
      {
        const item = n_items[i];
        if (item.status === 'exist' && item.checked)
        {
          out.push({quantity : item.quantity,item_id : item._id,type : 'exist'})
        }
        else if (item.status === 'suggest')
        {
          const s_items = item.items;
          for (let j = 0; j < s_items.length; j++)
          {
            const s_item = s_items[j];
            if (s_item.checked)
              out.push({quantity : s_item.quantity,item_id : s_item._id,type : 'suggest'})
          }
        }
      }
      const check = await this.preOrderSubmit({id : self.order._id,items : out});
      if (check.ok)
      {
        showSystemNoti('success',check.message,function (){
          self.$router.push({path : '/payment/'+self.order._id});
        });
      }
      else
        return showSystemNoti('danger',check.error);
    }
  },
  watch: {
    "$route.path": {
      handler(newUrl)
      {
        if (newUrl.toLowerCase().indexOf('preorder/info/') >= 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }
}

</script>

<style scoped>
.not-exist-div
{
  background: #e8bbbb !important;
}
.img
{
  width: 100%;
}
.input-number {
  width: 40%;
  vertical-align: top;
  text-align: center;
  outline: none;
  padding: 0;
}

.input-number,
.input-number-decrement,
.input-number-increment
{
  border: 1px solid #ccc;
  height: 40px;
  user-select: none;
}

.input-number-decrement,
.input-number-increment
{
  display: inline-block;
  width: 30%;
  line-height: 38px;
  background: #f1f1f1;
  color: #444;
  text-align: center;
  font-weight: bold;
  cursor: pointer;}


.input-number-decrement
{
  border-right: none;
  border-radius: 0 4px 4px 0;
}

.input-number-increment
{
  border-left: none;
  border-radius: 4px 0 0 4px;
}
.position-relative
{
  position: relative;
}
.del_btn{
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  display: block;
  z-index: 3;
}
.justify-between
{
  display: flex;
  justify-content: space-between;
}
.percent {
  background: #eb445a;
  color: white;
  font-size: 12px;
  border-radius: 4px;
  margin-left: 3px;
}
.mb-1
{
  margin-bottom: 5px;
}

.toggle {
  position: relative;
  /* top: 0; */
  /* bottom: 0; */
  /* right: 9px; */
  margin: auto;
  width: 80px;
  height: 26px;
  margin-top: 8px;
  margin-bottom: 5px;
}

.toggle label,
.toggle i {
  box-sizing: border-box;
  display: block;
  background: #ee212b;
}

.toggle label {
  width: 80px;
  height: 26px;
  border-radius: 32px;
  border: 2px solid #f1f2f2;
  transition: all 0.30s ease;
}

.toggle i {
  position: absolute;
  top: 3px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 28px;
  box-shadow: 0 0 1px 0 rgba(0,0,0, 0.25), 0 3px 3px 0 rgba(0,0,0, 0.15);
  background: #ffffff;
  transition: all 0.3s cubic-bezier(0.275, -0.450, 0.725, 1.450);
}


.checkbox:active + .toggle i {
  width: 35px;
}

.checkbox:active + .toggle label,
.checkbox:checked + .toggle label {
  border: 13px solid #28a745;
}

.checkbox:checked + .toggle i {
  left: 57px;
}

.checkbox:checked + .toggle i::before {
  content: 'تایید';
  position: absolute;
  left: -36px;
  font-size: 10px;
  top: 2px;
  color: white;
  font-weight: bold;
}

.checkbox:checked:active + .toggle label {
  border: 16px solid #28a745;
}

.checkbox:checked:active + .toggle i {
  left: 14px;
}

.checkbox + .toggle i::before {
  content: 'رد';
  position: absolute;
  left: 35px;
  font-size: 10px;
  top: 3px;
  font-weight: bold;
  color: white;
}

.suggest-item{
  border: 1px dashed white;
  background: #16718c91 !important;
}
.min-max-amount
{
  font-size: 12px;
  margin-top: 15px;
}
.pr-1
{
  padding-right: 5px;
}
</style>